import { ApiPlugin } from '@/plugins';
// in case fetching from RU with no cross-origin problems
// const RU = 'http://santefrd9.dev.klee.lan.net';

export default class EtrClass {
  static nid = window.drupalSettings?.sante_etr?.nid;

  static async getRubriqueData() {
    try {
      const response = await ApiPlugin.get(`/ajax/etr/heading/${this.nid}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching data from Rubrique page level 2 \n', e);
      return [];
    }
  }

  static async getHomeEtrData() {
    try {
      const response = await ApiPlugin.get(`/ajax/etr/homepage/${this.nid}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching data from home page level 1 \n', e);
      return [];
    }
  }

  static async getPeripleNavigation() {
    try {
      const response = await ApiPlugin.get(`/ajax/periple/content/navigation/${this.nid}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching data from Rubrique page level 2 \n', e);
      return [];
    }
  }

  static async getPeripleTree() {
    try {
      const response = await ApiPlugin.get(`/ajax/periple/tree/${this.nid}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching Periple tree \n', e);
      return [];
    }
  }

  static async getEtrMenu() {
    try {
      const response = await ApiPlugin.get(`/ajax/etr/header/${this.nid}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching data from menu \n', e);
      return [];
    }
  }
}
